module.exports = __webpack_public_path__ + "static/media/lawn mower.7b4f10e1.png";